import { ProjectParticleConfig } from './ProjectParticleConfig';
import { HeaderType } from 'app/views/project/project.types';

export enum TitleLineType {
	DOUBLE = 'double',
	SINGLE = 'single'
}

export interface ProjectConfig {
	slug: string;
	/** `false` removes the project from the carousel (WorkController.setJSON filter). */
	active?: boolean;
	/** Carousel position — WorkController.setJSON sorts by this, not by array order. */
	order: number;
	image: string;
	anchor?: number;
	/** Hex colour string, e.g. '0xe169ff' (the data was always a string — this was mistyped as number). */
	tint: string;
	/** Optional — absent on most projects. */
	titleLineType?: TitleLineType;
	/** Optional — ProjectController falls back to HeaderType.IMAGE when absent. */
	headerType?: HeaderType;
	topUiTheme?: string;
	particles: Array<ProjectParticleConfig>;
}
